import { render, staticRenderFns } from "./FormValidationExtend.vue?vue&type=template&id=52cb5392"
import script from "./FormValidationExtend.vue?vue&type=script&lang=js"
export * from "./FormValidationExtend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports